import { EventInput } from '@fullcalendar/core';

import { SuperModel } from './super-model.model';
import { Color } from './color.model';
import { EventCategory } from './event-category.model';

export class CalendarEvent extends SuperModel {
  title: string;
  location: string;
  startTime: Date;
  endTime: Date;
  description: boolean;
  eventCategory: EventCategory;

  constructor(data: Partial<CalendarEvent> = {}) {
    super(data);

    if (data.startTime) {
      this.startTime = new Date(data.startTime);
    }
    if (data.endTime) {
      this.endTime = new Date(data.endTime);
    }
  }

  get serialised() {
    if (this.startTime) {
      this.startTime.setHours(12, 0, 0);
    }
    if (this.endTime) {
      this.endTime.setHours(12, 0, 0);
    }
    return {
      id: this.id,
      title: this.title,
      location: this.location,
      startTime: this.startTime,
      endTime: this.endTime,
      description: this.description,
      eventCategory: this.eventCategory,
    };
  }

  augmentModelWithEventCategoryAndColor(
    eventsCategories: EventCategory[],
    colors: Color[] = []
  ): CalendarEvent {
    const eventCategory = eventsCategories.find(c => c.id === (this.eventCategory && this.eventCategory.id));
    this.eventCategory = eventCategory;
    if (eventCategory) {
      const eventColor = colors.find(c => c.id === (eventCategory.color && eventCategory.color.id));
      if (eventColor) {
        eventCategory.color = eventColor;
      }
    }

    return this;
  }

  createCalendarComponentEvent(
    eventsCategories: EventCategory[],
    colors: Color[] = []
  ): CalendarComponentEvent {
    const calendarEvent = this.augmentModelWithEventCategoryAndColor(eventsCategories, colors);
    const calendarComponentEvent = new CalendarComponentEvent({
      id: this.id,
      title: this.title,
      start: this.startTime,
      end: this.endTime,
      calendarEvent: this,
    });
    if (calendarEvent.eventCategory) {
      calendarComponentEvent.backgroundColor = calendarEvent.eventCategory.color.rgb;
    }
    return calendarComponentEvent;
  }
}

export class CalendarComponentEvent implements EventInput {
  id: string;
  title: string;
  start: Date;
  end: Date;
  textColor = '#333';
  borderColor = '#CCC';
  backgroundColor = '#CCC';

  calendarEvent: CalendarEvent;

  constructor(data: Partial<CalendarComponentEvent>) {
    Object.assign(this, data);
  }

  isValid() {
    return this.title && this.start && this.end;
  }
}
